import { AdjustmentTypePolicy } from "constants/charge/AdjustmentTypePolicy";
import { ChargeQtyAdjSearchCriteria } from "domain/entity/ChargeQtyAdj/ChargeQtyAdjSearchCriteria";
import { CreditNoteConstant, creditNoteHdrRequiredFieldList } from "presentation/constant/CreditNote/CreditNoteConstant";
import { useCreditNoteDetailVesselVM } from "presentation/hook/CreditNote/useCreditNoteDetailVesselVM";
import { useCreditNoteDetailVM } from "presentation/hook/CreditNote/useCreditNoteDetailVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useCreditNoteDetailTracked } from "presentation/store/CreditNote/CreditNoteDetailProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateTimePickerComponent from "presentation/view/components/DateTimePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { useCallback, useEffect, useMemo, useState } from "react";
import { FieldType, HPHInputMask, IFieldValue, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionCross, SidebarTitle, Sidebarheader, StyledSidebar } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
import CreditNoteVesselComp from "../../ArrivalAndDepaVessel/CreditNoteVesselComp";

export const CreditNoteHeaderFieldFormPanel = () => {

    const [creditNoteDetailState] = useCreditNoteDetailTracked();
    const creditNoteDetailVM = useCreditNoteDetailVM();
    const { isSaveClicked, allFormState, isAdd, isEditable, isRead, editingHeader, isShowDetailInfo, isShowInvoicePanel, isNormal, isAdjustmentRead } = creditNoteDetailState.creditNoteDetailState;
    const { creditNoteDetails, isExistLimit } = creditNoteDetailState;
    const CREDIT_NOTE_CONSTANT = CreditNoteConstant.Header;
    const messageBarVM = useMessageBarVM();
    const creditNoteDetailVesselVM = useCreditNoteDetailVesselVM();

    const currentCreditNoteHdr = (isRead && isNormal) ? creditNoteDetailState.currentCreditNoteHdr : editingHeader;

    const [anaInfoState] = useANAInfoTracked();
    const { allowUpdate, operatingUnit } = anaInfoState;
    const [isLoading, setIsLoading] = useState(false);

    const isEditDisable = () => {
        if (!(currentCreditNoteHdr.hdrState === "NIL" && creditNoteDetails && creditNoteDetails.length > 0)) return true;

        return false;
    }

    const isDisable = () => {
        if (!((isAdd && creditNoteDetails.length > 0 && !isShowDetailInfo && !isShowInvoicePanel) || (isEditable && (!isRead || !isNormal) && creditNoteDetails.length > 0 && !isShowDetailInfo && !isShowInvoicePanel))) return true;
        // if (!isRead && creditNoteDetails.length===0 && isShowDetailInfo) return true;

        return false;
    }

    const handleEdit = useCallback(() => {
        creditNoteDetailVM.onHeaderEdit(currentCreditNoteHdr, creditNoteDetails);
    }, [creditNoteDetailVM, creditNoteDetails, currentCreditNoteHdr]);

    const handleCoVslVoy = useCallback(() => {
        if (!currentCreditNoteHdr.billToCompany && !currentCreditNoteHdr.consortiumCode
            && !currentCreditNoteHdr.voyageCode && !currentCreditNoteHdr.vesselCode
            && !currentCreditNoteHdr.vesselName && !currentCreditNoteHdr.etd
        ) {
            const msg = 'Please input Bill-To Company, Consortium Code, Vessel Code, Voyage Code, Vessel Name, Dep Date Time at least;';
            messageBarVM.showError(msg, true);
            return;
        }
        setIsLoading(true);
        const vesselSearchCriteria: ChargeQtyAdjSearchCriteria = {
            billToCompany: currentCreditNoteHdr.billToCompany,
            conCode: currentCreditNoteHdr.consortiumCode,
            voyCode: currentCreditNoteHdr.voyageCode,
            vslCode: currentCreditNoteHdr.vesselCode,
            vslName: currentCreditNoteHdr.vesselName,
            depDate: currentCreditNoteHdr.etd
        }
        creditNoteDetailVesselVM.initSearch(vesselSearchCriteria).then((data) => {
            setIsLoading(false);
            creditNoteDetailVesselVM.onShowPanel();
        })
    }, [currentCreditNoteHdr.billToCompany, currentCreditNoteHdr.consortiumCode, currentCreditNoteHdr.voyageCode, currentCreditNoteHdr.vesselCode, currentCreditNoteHdr.etd, currentCreditNoteHdr.vesselName, creditNoteDetailVesselVM, messageBarVM])

    const handleSave = useCallback(async () => {
        if (creditNoteDetails.length > 0) {
            let validatedResult: { [x: string]: string } = {};
            if (isExistLimit && !currentCreditNoteHdr.reqNo) {
                validatedResult = { ...validatedResult, reqNo: 'Missing.' };
            }
            if (!currentCreditNoteHdr.customerCode) {
                validatedResult = { ...validatedResult, customerCode: 'Missing.' };
            }
            if (operatingUnit === 'SAPT' || operatingUnit === 'KICT') {
                let isError = false;
                creditNoteDetails.forEach(async (creditNoteDetail) => {
                    if (creditNoteDetail.adjType && creditNoteDetail.adjType !== AdjustmentTypePolicy.TEXT_NORMAL && !creditNoteDetail.creditNoteNature) {
                        isError = true;
                        return;
                    }
                })
                if (isError) {
                    validatedResult = { ...validatedResult, creditNoteNature: 'Missing.' };
                    const msg = 'Please input Credit Note Nature.';
                    messageBarVM.showError(msg, true);
                }
            }

            creditNoteDetailVM.onShowLoading();
            await creditNoteDetailVM.onTitleSaveClick(currentCreditNoteHdr, creditNoteDetails, validatedResult).then((data) => {
                if (data && typeof data?.id === 'number') {
                    messageBarVM.showSuccess("Save Successfully.");
                    creditNoteDetailVM.onHideLoading();
                }
            }).catch((error) => {
                creditNoteDetailVM.onHideLoading();
            }).finally(() => {
                creditNoteDetailVM.onHideLoading();
            })
        }
    }, [creditNoteDetailVM, creditNoteDetails, currentCreditNoteHdr, isExistLimit, operatingUnit, messageBarVM]);

    useEffect(() => {
        const refreshReqNo = async () => {
            if (currentCreditNoteHdr?.currencyCode) {
                creditNoteDetailVM.onRefreshReqNo(currentCreditNoteHdr?.currencyCode);
            }
        }
        (operatingUnit === 'SAPT' || operatingUnit === 'KICT') && refreshReqNo();
    }, [operatingUnit, currentCreditNoteHdr?.currencyCode, creditNoteDetailVM])

    useEffect(() => {
        const refreshCustomerCode = async () => {

            if (currentCreditNoteHdr.billToCompany) {
                creditNoteDetailVM.initCustomerCodeByBillTo(currentCreditNoteHdr.billToCompany);
            } else {
                creditNoteDetailVM.initCustomerCode();
            }
        }
        refreshCustomerCode();
    }, [creditNoteDetailVM, currentCreditNoteHdr.billToCompany])

    const memoSpliceConVslCode = useMemo(() => {

        const conVslCode = (currentCreditNoteHdr?.consortiumCode || '') + '/' + (currentCreditNoteHdr?.vesselCode || '') + '/' + (currentCreditNoteHdr?.voyageCode || '') + '/' + (currentCreditNoteHdr?.vesselName || '');
        if (conVslCode === '///') {
            return '';
        }
        return conVslCode;
    }, [currentCreditNoteHdr?.consortiumCode, currentCreditNoteHdr?.vesselCode, currentCreditNoteHdr?.voyageCode, currentCreditNoteHdr?.vesselName])

    const memoState = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: "47.5%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteHdr?.hdrState || ''}
                fieldValue={currentCreditNoteHdr?.hdrState}
                fieldLabel={CREDIT_NOTE_CONSTANT.STATE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'hdrState'}
                maxLength={60}
                requiredFieldList={creditNoteHdrRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), operatingUnit, fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.STATE, allFormState, creditNoteDetailVM, currentCreditNoteHdr?.hdrState, isSaveClicked, operatingUnit])


    const memoChargeType = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: "47.5%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={(currentCreditNoteHdr?.chargeType) || ''}
                fieldValue={currentCreditNoteHdr?.chargeType}
                fieldLabel={CREDIT_NOTE_CONSTANT.CHARGE_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'chargeType'}
                maxLength={60}
                requiredFieldList={creditNoteHdrRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), operatingUnit, fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.CHARGE_TYPE, allFormState, creditNoteDetailVM, currentCreditNoteHdr?.chargeType, isSaveClicked, operatingUnit])

    const memoEtd = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: "47.5%", marginBottom: "24px" }}>
            <DateTimePickerComponent
                disabled={isRead}
                label={CREDIT_NOTE_CONSTANT.DEPATURE_DATETIME}
                width="200px"
                date={currentCreditNoteHdr?.etd}
                fieldName="etd"
                optional={true}
                errorMessage={allFormState ? allFormState["validateRangeDate"] : ""}
                onDateChange={creditNoteDetailVM.onHeaderFieldChange} />
        </div>
        , [CREDIT_NOTE_CONSTANT.DEPATURE_DATETIME, allFormState, creditNoteDetailVM, currentCreditNoteHdr?.etd, isRead])

    const memoCoVslVoyText = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "200px", maxWidth: "430px", width: "100%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={memoSpliceConVslCode}
                fieldValue={memoSpliceConVslCode}
                fieldLabel={CreditNoteConstant.Detail.CONS_VSL_VOY_VESSEL_NAME}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'consortiumCode'}
                isShowMissingError={false}
                requiredFieldList={[]}
                onFieldChange={() => { }} />
        </div>
        , [isSaveClicked, memoSpliceConVslCode])

    const memoCoVslVoy = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "200px", maxWidth: "430px", width: "100%", marginBottom: "24px" }}>
            <HPHInputMask
                label={CreditNoteConstant.Detail.CONS_VSL_VOY_VESSEL_NAME}
                width={'100%'}
                disabled={isRead || isAdjustmentRead}
                optional={true}
                autoFocus={false}
                value={{
                    co: currentCreditNoteHdr?.consortiumCode ?? '',
                    vsl: currentCreditNoteHdr?.vesselCode ?? '',
                    voy: currentCreditNoteHdr?.voyageCode ?? '',
                    vel: currentCreditNoteHdr?.vesselName ?? ''
                }}
                fieldConfiguration={{
                    co: { maxLength: 4, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
                    vsl: { maxLength: 6, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
                    voy: { maxLength: 10, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
                    vel: { maxLength: 30, autoComplete: "off", valueInNormalCase: true, isNumeric: false },
                }}
                onDataChange={(e: any) => creditNoteDetailVM.onCoVslVoyChange(e, {
                    co: 'consortiumCode',
                    vsl: 'vesselCode',
                    voy: 'voyageCode',
                    vel: 'vesselName'
                })} />
        </div>
        , [creditNoteDetailVM, currentCreditNoteHdr?.consortiumCode, currentCreditNoteHdr?.vesselCode, currentCreditNoteHdr?.vesselName, currentCreditNoteHdr?.voyageCode, isAdjustmentRead, isRead])

    const memoYourRef = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: "47.5%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteHdr?.yourRef || ''}
                fieldValue={currentCreditNoteHdr?.yourRef}
                fieldLabel={CREDIT_NOTE_CONSTANT.YOUR_REF}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'yourRef'}
                maxLength={100}
                requiredFieldList={creditNoteHdrRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), operatingUnit, fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.YOUR_REF, allFormState, creditNoteDetailVM, currentCreditNoteHdr?.yourRef, isRead, isSaveClicked, operatingUnit])

    const memoOurRef = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: "47.5%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteHdr?.ourRef || ''}
                fieldValue={currentCreditNoteHdr?.ourRef}
                fieldLabel={CREDIT_NOTE_CONSTANT.OUR_REF}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'ourRef'}
                maxLength={100}
                requiredFieldList={creditNoteHdrRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), operatingUnit, fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.OUR_REF, allFormState, creditNoteDetailVM, currentCreditNoteHdr?.ourRef, isRead, isSaveClicked, operatingUnit])

    const memoOperatingTml = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: "47.5%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteHdr?.operatingTml || ''}
                fieldValue={currentCreditNoteHdr?.operatingTml}
                fieldLabel={CREDIT_NOTE_CONSTANT.OPERATING_TML}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'operatingTml'}
                options={creditNoteDetailState.dynamicOptions.operatingTmlDropdownOptions}
                maxLength={60}
                requiredFieldList={creditNoteHdrRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), operatingUnit, fFullValue)} />
        </div>
        , [allFormState, isRead, currentCreditNoteHdr?.operatingTml, CREDIT_NOTE_CONSTANT.OPERATING_TML, isSaveClicked, creditNoteDetailState.dynamicOptions.operatingTmlDropdownOptions, creditNoteDetailVM, operatingUnit])

    const memoReqNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: "47.5%", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={isRead && isNormal}
                isShowOptional={!isExistLimit}
                readOnlyValue={currentCreditNoteHdr?.reqNo || ''}
                fieldValue={currentCreditNoteHdr?.reqNo}
                fieldLabel={CREDIT_NOTE_CONSTANT.REQ_NO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'reqNo'}
                options={creditNoteDetailState.dynamicOptions.reqNoDropdownOptions}
                maxLength={60}
                errorMessage={allFormState ? allFormState["reqNo"] : ""}
                requiredFieldList={creditNoteHdrRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), operatingUnit, fFullValue)} />
        </div>
        , [isRead, isNormal, isExistLimit, currentCreditNoteHdr?.reqNo, CREDIT_NOTE_CONSTANT.REQ_NO, isSaveClicked, creditNoteDetailState.dynamicOptions.reqNoDropdownOptions, allFormState, creditNoteDetailVM, operatingUnit])

    const memoHdrDesc1 = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: "47.5%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteHdr?.hdrDesc1 || ''}
                fieldValue={currentCreditNoteHdr?.hdrDesc1}
                fieldLabel={CREDIT_NOTE_CONSTANT.HDR_DESC1}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'hdrDesc1'}
                maxLength={200}
                requiredFieldList={creditNoteHdrRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), operatingUnit, fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.HDR_DESC1, allFormState, creditNoteDetailVM, currentCreditNoteHdr?.hdrDesc1, isRead, isSaveClicked, operatingUnit])

    const memoHdrDesc2 = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: "47.5%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteHdr?.hdrDesc2 || ''}
                fieldValue={currentCreditNoteHdr?.hdrDesc2}
                fieldLabel={CREDIT_NOTE_CONSTANT.HDR_DESC2}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'hdrDesc2'}
                maxLength={200}
                requiredFieldList={creditNoteHdrRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), operatingUnit, fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.HDR_DESC2, allFormState, creditNoteDetailVM, currentCreditNoteHdr?.hdrDesc2, isRead, isSaveClicked, operatingUnit])

    const memoBillToCompany = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: "47.5%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteHdr?.billToCompany || ''}
                fieldValue={currentCreditNoteHdr?.billToCompany}
                fieldLabel={CREDIT_NOTE_CONSTANT.BILL_TO_COMPANY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'billToCompany'}
                maxLength={60}
                requiredFieldList={creditNoteHdrRequiredFieldList}
                isLimitOptions={true}
                options={creditNoteDetailState.dynamicOptions.billToCompDropdownOptions}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), operatingUnit, fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.BILL_TO_COMPANY, allFormState, creditNoteDetailState.dynamicOptions.billToCompDropdownOptions, creditNoteDetailVM, currentCreditNoteHdr?.billToCompany, isRead, isSaveClicked, operatingUnit])

    const memoCustomerCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: "47.5%", marginBottom: "24px" }}>
            <NbisCommonField
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteHdr?.customerCode || ''}
                fieldValue={currentCreditNoteHdr?.customerCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.CUSTOMER_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'customerCode'}
                maxLength={60}
                errorMessage={allFormState ? allFormState["customerCode"] : ""}
                requiredFieldList={creditNoteHdrRequiredFieldList}
                options={creditNoteDetailState.dynamicOptions.customerCodeDropdownOptions}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), operatingUnit, fFullValue)} />
        </div>
        , [allFormState, isRead, currentCreditNoteHdr?.customerCode, CREDIT_NOTE_CONSTANT.CUSTOMER_CODE, isSaveClicked, creditNoteDetailState.dynamicOptions.customerCodeDropdownOptions, creditNoteDetailVM, operatingUnit])

    const memoPoNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: "47.5%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteHdr?.poNo || ''}
                fieldValue={currentCreditNoteHdr?.poNo}
                fieldLabel={CREDIT_NOTE_CONSTANT.PO_NO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'poNo'}
                maxLength={90}
                requiredFieldList={creditNoteHdrRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), operatingUnit, fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.PO_NO, allFormState, creditNoteDetailVM, currentCreditNoteHdr?.poNo, isRead, isSaveClicked, operatingUnit])

    const memoSlVesselCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: "47.5%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteHdr?.slVesselCode || ''}
                fieldValue={currentCreditNoteHdr?.slVesselCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.SL_VESSEL_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'slVesselCode'}
                maxLength={40}
                isTextFieldCapitalize={true}
                requiredFieldList={creditNoteHdrRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), operatingUnit, fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.SL_VESSEL_CODE, allFormState, creditNoteDetailVM, currentCreditNoteHdr?.slVesselCode, isRead, isSaveClicked, operatingUnit])

    const memoSlIbVoyageCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: "47.5%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteHdr?.slIbVoyageCode || ''}
                fieldValue={currentCreditNoteHdr?.slIbVoyageCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.SL_IB_VOYAGE_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'slIbVoyageCode'}
                maxLength={40}
                isTextFieldCapitalize={true}
                requiredFieldList={creditNoteHdrRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), operatingUnit, fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.SL_IB_VOYAGE_CODE, allFormState, creditNoteDetailVM, currentCreditNoteHdr?.slIbVoyageCode, isRead, isSaveClicked, operatingUnit])

    const memoSlObVoyageCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ minWidth: "200px", maxWidth: "200px", width: "47.5%", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isRead}
                isShowOptional={true}
                readOnlyValue={currentCreditNoteHdr?.slObVoyageCode || ''}
                fieldValue={currentCreditNoteHdr?.slObVoyageCode}
                fieldLabel={CREDIT_NOTE_CONSTANT.SL_OB_VOYAGE_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'slObVoyageCode'}
                maxLength={40}
                isTextFieldCapitalize={true}
                requiredFieldList={creditNoteHdrRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    creditNoteDetailVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), operatingUnit, fFullValue)} />
        </div>
        , [CREDIT_NOTE_CONSTANT.SL_OB_VOYAGE_CODE, allFormState, creditNoteDetailVM, currentCreditNoteHdr?.slObVoyageCode, isRead, isSaveClicked, operatingUnit])

    return <>
        <div className='side-form-content-left-wrapper'>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <StyledSidebar style={{ width: '100%', height: "100%", border: 'none', backgroundColor: '#FFFFFF', overflow: 'auto', padding: '0' }} position='right'>
                        <Sidebarheader style={{ width: '100%' }}>
                            <SidebarTitle>{currentCreditNoteHdr.creditChargeNo ?? "HEADER"}</SidebarTitle>
                            <SidebarActionCross>
                                {(!isAdd && (isEditable && isRead && isNormal)) &&
                                    <>
                                        {
                                            (
                                                (isEditable && allowUpdate)
                                            )
                                            && <IconButton fileName='Icon-pen' size='medium' disabled={isEditDisable()} toolTipText={'Edit'} toolTipArrow={false} onClick={handleEdit} />
                                        }
                                    </>}
                                {/*<IconButton fileName="Icon-cross" size="medium" disabled={!isRead && isShowDetailInfo} toolTipArrow={false} toolTipPlacement="left" toolTipText={'Close'} onClick={handleClose} />*/}
                                {((isAdd || (isEditable && (!isRead || !isNormal)))) &&
                                    <>
                                        {/* <IconButton fileName="Icon-reset" size="medium" toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Reset'} onClick={handleReset} /> */}
                                        {
                                            (
                                                (isAdd) ||
                                                (isEditable && (!isRead || !isNormal))
                                            )
                                            && <IconButton fileName="Icon-tick" size="medium" disabled={isDisable()} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Save'} onClick={() => handleSave()} />
                                        }
                                    </>}
                            </SidebarActionCross>

                        </Sidebarheader>

                    </StyledSidebar>
                </div>
            </div>

            {/* {memoHdrForm} */}
            {isLoading && <Loader Indicator="Spinner" size="Medium" />}

            <div className={'add-edit-form'} style={{ height: '78vh', maxHeight: '78vh', overflow: 'auto', margin: "0px 0px 20px 0px" }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        <CriteriaItemContainer>
                            {memoState}{memoChargeType}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoReqNo}{memoEtd}
                        </CriteriaItemContainer>
                        {(isRead || isAdjustmentRead) ?
                            <CriteriaItemContainer>
                                {memoCoVslVoyText}
                            </CriteriaItemContainer> :
                            <CriteriaItemContainer>
                                <div className={"customContainer"}>
                                    {memoCoVslVoy}
                                    {(!isRead && !isAdjustmentRead) && <div className='password-eye manual-dtl-coVslVoy'>
                                        <IconButton fileName="Icon-more" tooltipDisable={true} size="medium" disabled={false} onClick={handleCoVslVoy} /></div>}
                                </div>
                            </CriteriaItemContainer>
                        }
                        <CriteriaItemContainer>
                            {memoCustomerCode}
                            {memoBillToCompany}

                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoPoNo}
                            {memoOperatingTml}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoYourRef}{memoOurRef}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoHdrDesc1}{memoHdrDesc2}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoSlIbVoyageCode}
                            {memoSlObVoyageCode}
                        </CriteriaItemContainer>
                        <CriteriaItemContainer>
                            {memoSlVesselCode}
                        </CriteriaItemContainer>
                    </div>
                </div>
            </div>

            {creditNoteDetailState.isShowFindVesselPanel && <CreditNoteVesselComp />}
        </div>
    </>
}